import styles from "@/components/edit-shortcut-back-button.module.css";
import { EditShortcutPopupPage } from "@/types";
import { t } from "i18next";
import { JSX } from "react";

interface EditShortcutBackButtonProps {
	setCurrentPage: (newValue: EditShortcutPopupPage) => void;
}

function EditShortcutBackButton({
	setCurrentPage,
}: EditShortcutBackButtonProps): JSX.Element {
	const handleClick = (): void => {
		setCurrentPage(EditShortcutPopupPage.MAIN);
	};

	return (
		<button
			className={styles["back-button"]}
			onClick={handleClick}
			title={t("back")}
			type="button"
		>
			<i>&#xe77d;</i>
		</button>
	);
}

export default EditShortcutBackButton;
